import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/jiantou-down.png'
import _imports_1 from '../assets/images/jiiantou-up.png'


const _withScopeId = n => (_pushScopeId("data-v-557711f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page detailed" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "我的童币", -1))
const _hoisted_4 = { class: "number" }
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = {
  key: 0,
  class: "grant-list"
}
const _hoisted_7 = { class: "item-top-box" }
const _hoisted_8 = { class: "item-left" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "item-right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text1" }, "+", -1))
const _hoisted_13 = { class: "text1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text2" }, "童币", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-text" }, "无更多数据", -1))
const _hoisted_16 = {
  key: 0,
  class: "exchange-list"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "item-left" }
const _hoisted_19 = { class: "time" }
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "item-right" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text1" }, "-", -1))
const _hoisted_23 = { class: "text1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text2" }, "童币", -1))
const _hoisted_25 = {
  key: 0,
  class: "down-icon",
  src: _imports_0
}
const _hoisted_26 = {
  key: 1,
  class: "down-icon",
  src: _imports_1
}
const _hoisted_27 = {
  key: 0,
  class: "item-down-box"
}
const _hoisted_28 = { class: "item-left" }
const _hoisted_29 = { class: "item-btn" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-text" }, "无更多数据", -1))

import { Toast } from 'vant'
import NoData from '@/components/NoData.vue'
import Divider from '@/components/Divider.vue'
import { queryAccountIntegralFlows, queryAccountOutIntegralDetail, queryUserAccount } from '@/apis/public'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const active = ref(route.query.type)
const handleChangeTab = (type) => {
  active.value = type
  handleGetData()
}
const flowList = ref([])
const handlequeryAccountIntegralFlows = async () => {
  const res = await queryAccountIntegralFlows({})
  if (res.code === 0) {
    flowList.value = res.data
  } else {
    Toast(res.message)
  }
}
const exchangeList = ref([])
const handleQueryOutIntegralDetail = async () => {
  const res = await queryAccountOutIntegralDetail({})
  if (res.code === 0) {
    exchangeList.value = res.data
    exchangeList.value.forEach(element => {
      element.isOpen = false
    });
  } else {
    Toast(res.message)
  }
}
const handleGetData = () => {
  if (active.value === '1') {
    handlequeryAccountIntegralFlows()
  } else {
    handleQueryOutIntegralDetail()
  }
}
const handleToCard = () => {
  router.push({
    name: 'Card'
  })
}
const integral = ref(0)
const handleQueryUserAccount = async () => {
  const res = await queryUserAccount({})
  if (res.code === 0) {
    integral.value = res.data.integral
  }
}
handleQueryUserAccount()
onMounted(() => {
  handleGetData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(integral.value), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(active.value==='1' ? 'active' : ''),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeTab('1')))
      }, "发放明细", 2),
      _createElementVNode("div", {
        class: _normalizeClass(active.value==='2' ? 'active' : ''),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeTab('2')))
      }, "兑换明细", 2)
    ]),
    (active.value==='1')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (flowList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "grant-item",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(item.grantTimeStr), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(item.activityName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.grantNum), 1),
                        _hoisted_14
                      ])
                    ])
                  ]))
                }), 128)),
                _createVNode(Divider, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(NoData, { key: 1 }))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (exchangeList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exchangeList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "exchange-item",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: "item-top-box",
                      onClick: ($event: any) => (exchangeList.value[index].isOpen = !exchangeList.value[index].isOpen)
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(item.grantTime), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(item.goodName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(item.integral), 1),
                        _hoisted_24,
                        (!exchangeList.value[index].isOpen)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                          : (_openBlock(), _createElementBlock("img", _hoisted_26))
                      ])
                    ], 8, _hoisted_17),
                    (item.isOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", null, "订单编号: " + _toDisplayString(item.orderNo), 1),
                            _createElementVNode("div", null, "订单状态: " + _toDisplayString(item.info), 1),
                            _createElementVNode("div", null, "下单类型: " + _toDisplayString(item.opUserTypeStr), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "item-right",
                            onClick: handleToCard
                          }, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(item.receiveStr), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _createVNode(Divider, null, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(NoData, { key: 1 }))
        ], 64))
  ]))
}
}

})